<template>
  <GobSection id="que-es" tono="electrico" ritmo="amplio" class="relative overflow-hidden [--color-focus-ring:#FFFFFF]">
    <img
      :src="patronDecorativo01"
      alt=""
      aria-hidden="true"
      class="gob-patron-decorativo left-50 bottom-85 w-60 opacity-50"
    />
    <img
      :src="patronDecorativo03"
      alt=""
      aria-hidden="true"
      class="gob-patron-decorativo right-35 -top-15 w-90 opacity-50"
    />
    <img
      :src="patronDecorativo02"
      alt=""
      aria-hidden="true"
      class="gob-patron-decorativo right-50 -bottom-25 w-80 opacity-50"
    />
    <div class="grid gap-8 ">
      <h2 class="text-gob-7 leading-[1.05] font-black tracking-gob-tightest text-balance text-white">
        Una <span class="bg-surface-deep rounded-2xl px-2">ciudad inteligente</span> no empieza con cámaras ni sensores.
      </h2>
      <h2 class="text-gob-7 leading-[1.05] font-bold tracking-gob-tightest text-balance text-white -mt-2 md:-mt-4">
        Empieza comprendiendo mejor <span class="bg-surface-deep rounded-2xl px-2">las necesidades de las personas.</span>
      </h2>
      <div class="text-gob-2 leading-relaxed text-white">
        <p>
          Gob 24/7 reúne en un solo lugar la gestión pública e institucional: la información deja de estar repartida 
          entre organismos, archivos y sistemas que no se hablan, y se convierte en contexto para decidir. 
          Así su entidad sabe a quién atender primero, qué metas avanzan y dónde actuar mientras todavía hay tiempo.
        </p>
      </div>
    </div>

    <ul class="mt-14 grid gap-6 md:mt-20 md:grid-cols-3" role="list">
      <li v-for="pilar in pilares" :key="pilar.nombre">
        <HomePilarCard v-bind="pilar" />
      </li>
    </ul>
  </GobSection>
</template>

<script>
import GobSection from '@/components/GobSection.vue'
import HomePilarCard from '@/components/home/HomePilarCard.vue'
import imagenEmocion from '@/assets/home/emocion.webp'
import imagenImpacto from '@/assets/home/ciudadana.webp'
import imagenTransparencia from '@/assets/home/pilar-transparencia.webp'
import patronDecorativo01 from '@/assets/home/patron01.svg'
import patronDecorativo02 from '@/assets/home/patron02.svg'
import patronDecorativo03 from '@/assets/home/patron03.svg'

const PILARES = [
  {
    nombre: 'Emoción',
    titulo: 'La calidad de vida, en el centro',
    descripcion: 'Cada decisión parte de una pregunta: ¿mejora la vida de la gente? Gob 24/7 pone el bienestar de cada ciudadano en el centro de la gestión.',
    imagen: imagenEmocion,
    tono: 'humano'
  },
  {
    nombre: 'Transparencia',
    titulo: 'Información en la que se puede confiar',
    descripcion: 'Datos trazables y actualizados en tiempo real: cada cambio queda registrado y la gestión se puede verificar.',
    imagen: imagenTransparencia,
    tono: 'dato',
    posicion: '30% center'
  },
  {
    nombre: 'Impacto',
    titulo: 'Resultados, ciudadano por ciudadano',
    descripcion: 'Con el Índice de Vulnerabilidad medimos lo que de verdad cambia: cuánto mejora la vida de cada persona atendida, no cuántas actividades se hicieron.',
    imagen: imagenImpacto,
    tono: 'marca',
    posicion: '35% center'
  }
]

/**
 * HomeQueEs
 * Tesis de ciudad inteligente sobre superficie clara y los tres pilares (Emoción, Transparencia, Impacto).
 * El párrafo no nombra productos concretos: habla de la gestión pública e institucional.
 */
export default {
  name: 'HomeQueEs',
  components: { GobSection, HomePilarCard },
  data() {
    return { pilares: PILARES, patronDecorativo01, patronDecorativo02, patronDecorativo03 }
  }
}
</script>
